export default [{
        path: '/feedbackReport',
        name: 'feedbackReport',
        component: () =>
            import ('@/components/page/storeFeedback/reportList'),
        meta: { title: '调查报告' } //
    },
    {
        path: '/feedbackReport/new',
        name: 'createfeedbackReport',
        component: () =>
            import ('@/components/page/storeFeedback/reportDetail'),
        meta: { title: '调查报告' } //
    },
    {
        path: '/feedbackReport/view',
        name: 'feedbackReportView',
        component: () =>
            import ('@/components/page/storeFeedback/reportDetail'),
        meta: { title: '调查报告' } //
    },
    {
        path: '/feedbackReport/audit',
        name: 'feedbackReportAudit',
        component: () =>
            import ('@/components/page/storeFeedback/reportDetail'),
        query: { action: 'audit' },
        meta: { title: '调查报告' } //
    },
    {
        path: '/feedbackReport/approve',
        name: 'feedbackReportApprove',
        component: () =>
            import ('@/components/page/storeFeedback/approveReport/approveDetail'),
        meta: { title: '审批' } //
    },
]